import React, { useEffect, useState } from "react";
import { Modal, Typography, Button, Grid, List, ListItem, Collapse, styled } from "@mui/material";
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormHelperText from '@mui/material/FormHelperText';
import FetchVerbruikEstimate from "./FetchVerbruikEstimate";
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import HomeIcon from '@mui/icons-material/Home'; // Standaard icoon voor huis
import PeopleIcon from '@mui/icons-material/People'; // Standaard icoon voor personen
/**
 * Return a box with two questions: 1: type of house, 2: household size
 * house options:
 * Appartement
 * Tussenwoning
 * Hoekwoning
 * Vrijstaand
 * 
 * Household size options:
 * 1 persoon
 * 2 personen
 * 3 personen
 * 4 personen
 * 5 of meer
 * 
 * @param {*} param0 

 */

export default function ParticulierVerbruikInschatterBoxStep2({
    selectedBuildingType,
    setSelectedBuildingType,
    householdSize,
    setIsFetchingData,
    setVerbruikEstimaterStep2Output,
    agentID


}) {

    const CustomIcon = ({ iconClass }) => (
        <div className = "icon-text-wrapper">
        <div className={iconClass}></div>
        </div>
    );

    const FullWidthButton = styled(Button)(({ theme }) => ({
        width: 'calc(100% - ' + theme.spacing(2) + ')', // Trek de totale padding af van de breedte
        margin: theme.spacing(1), // Set een kleine margin voor elke kant
      }));

    useEffect(() => {
        if (selectedBuildingType) {
            handleBuildingTypeChange(selectedBuildingType);
        } else {
            setSelectedBuildingType('Appartement');
        }

        if (selectedBuildingType && householdSize) {

            // convert personen strings to numbers.
            const householdSizeNumber = parseInt(householdSize.split(' ')[0]);

            const fetchData = async () => {
                try {
                    const results = await FetchVerbruikEstimate({
                        householdSize: householdSizeNumber,
                        selectedBuildingType: selectedBuildingType.toLowerCase(),
                        entity: 'Particulier',
                        setIsFetchingData,
                        agentID
                    });
                    // Zorg ervoor dat results beschikbaar is wanneer de functie wordt aangeroepen.
                    setVerbruikEstimaterStep2Output(results);
                } catch (error) {
                    console.error("Er is een fout opgetreden bij het ophalen van de verbruiksschatting:", error);
                    // Mogelijke foutafhandeling
                }
            };

            fetchData();



        }


    }, [selectedBuildingType, householdSize]);




    const handleBuildingTypeChange = (type) => {
        setSelectedBuildingType(type);
    };


    return (
        <Box padding={2}>
      <Typography variant="h6" color="#007681">
        In welk type huis woon je?
      </Typography>

      <List>
        {[
          { type: 'Appartement', Icon: HomeIcon },
          { type: 'Tussenwoning', Icon: HomeIcon },
          { type: 'Hoekwoning', Icon: HomeIcon },
          { type: 'Vrijstaand', Icon: HomeIcon }
        ].map(({ type, Icon }) => (
          <ListItem key={type}>
            <FullWidthButton
              startIcon={<CustomIcon iconClass={`icon-as-${type.toLowerCase()} icon-size`} />}
              variant={selectedBuildingType === type ? "contained" : "outlined"}
              onClick={() => handleBuildingTypeChange(type)}
            >
              {type}
            </FullWidthButton>
          </ListItem>
        ))}
      </List>
    </Box>
    );
}